import React from 'react';
import { connect } from 'react-redux';

import Loading from 'src/Components/Loading';
import { QueryComponent } from 'src/GraphQL';
import { queryConfirmAdmissionMyInfo } from 'src/GraphQL/query/ConfirmAdmission.query';
import { myProfile } from 'src/Redux/user-profile/selectors';

import AdmissionDB from './AdmissionDB';
import ConfirmAdmissionLanding from './ConfirmAdmissionLanding';

const dataSchema = {
  year: 2018,

  pictureId: 'chula.png',
  facebookGroupId: 'facebookGroup',
  myQuote: 'ติดแล้ววววว',

  deptId: 'Department Id',

  deptName: 'Department Name',
  facultyId: 'Faculty Id',
  facultyName: 'Faculty Name',
  facultyTagId: 'Education Group',
  universityId: 'University Id',
  universityName: 'University Name',

  firstName: 'Firstname',
  lastName: 'Lastname',
  email: 'test@tcaster.net',
  telNo: '0868881111',

  grade: 'M6',
  major: 'ART_MATH',
  school: 'บ้านหนองเลิน',
  schoolId: '9999',
  schoolProvince: 'กรุงเทพ',

  haveFavList: true,
  isInFavList: true,
};

function LandingSelector(props) {
  let params = new URLSearchParams(props.location.search);
  const f = params.get('f');
  return (
    <AdmissionDB>
      {({ isLoading, admissionDetail, onCreateAdmissionDetail, onDeleteAdmissionDetail }) => {
        const isForceStep1 = !!f;
        if (isLoading) {
          return <Loading />;
        }
        return (
          <ConfirmAdmissionLanding
            {...props}
            onCreateAdmissionDetail={onCreateAdmissionDetail}
            onDeleteAdmissionDetail={onDeleteAdmissionDetail}
            admissionDetails={isForceStep1 ? null : admissionDetail}
            myInfo={{ myProfile: props.myProfile }}
          />
        );
      }}
    </AdmissionDB>
  );
}

const mapStateToProps = state => ({
  myProfile: myProfile(state),
});

export default connect(mapStateToProps)(LandingSelector);
